import React from 'react'
import About from './About'
import Contact from './Contact'
import Header from './Header'
import Profile from './Profile'
import Resume from './Resume'
import Work from './Work'

const CardContainer = () => {
    return (
        <>
            <div className="container opened" data-animation-in="fadeInUp" data-animation-out="fadeOutRight">
                <Header />
                <Profile />
                <About />
                <Resume />
                <Work />
                <Contact />
            </div>
        </>
    )
}

export default CardContainer